(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  const openBtn = document.querySelector('[data-menu-open]');

  if (menu && openBtn && typeof menu.showModal === 'function') {
    const close = () => {
      menu.close();
    };

    openBtn.addEventListener('click', () => {
      menu.showModal();
      openBtn.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('close', () => {
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    });

    menu.querySelectorAll('[data-menu-close]').forEach((btn) => btn.addEventListener('click', close));

    // Clicks on the ::backdrop land on the dialog element itself.
    menu.addEventListener('click', (event) => {
      if (event.target === menu) close();
    });

    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches && menu.open) close();
    });
  }

  const header = document.querySelector('[data-header]');
  if (header && header.classList.contains('site-header--sticky')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
